import { DeviceType } from './device-type';

export class Util {

    public static isEmpty(obj:any):boolean {

        if(obj === null || obj === '' || typeof obj === 'undefined' ){
            return false;
        }

        for(const prop in obj) {
            if(obj.hasOwnProperty(prop)) {
                return false;
            }
        }

        return JSON.stringify(obj) === JSON.stringify({});
    }

    public static isLocationProtocolSecured(protocol: string) {
        if (protocol !== 'https:') {
            return false;
        } else {
            return true;
        }
    }

    public static isBrowserInternetExplorer() {
        const userAgent = navigator.userAgent.toLowerCase();
        return userAgent.indexOf('msie') > -1 || userAgent.indexOf('trident/') > -1;
    }

    public static loadInternetExplorerSupportScript(internetExplorerSupportFile: string, callback: any) {
        const script = document.createElement('script');
        script.setAttribute('src', internetExplorerSupportFile);
        script.async = true;
        script.onload = () => {
            callback();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    public static getUrlParameter(name: any, url: any) {
        if (!url) {
            url = location.href;
        }
        name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
        const regexS = '[\\?&]' + name + '=([^&#]*)';
        const regex = new RegExp(regexS);
        const results = regex.exec(url);
        return results == null ? null : results[1];
    }

    public static getDeviceType() {
        const userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf('android') > -1) {
            return DeviceType.ANDROID;
        }
        if (userAgent.indexOf('iphone') > -1) {
            return DeviceType.IPHONE;
        }
        return DeviceType.OTHER;
    }

    public static isForcedTestMode() {
        const dfTest = this.getUrlParameter('df-test', window.location.href);
        return dfTest !== null && dfTest === 'true';
    }

    public static isDfScriptV2() {
        const dfWidgetJsScript =  document?.querySelector('script#df-widget-js');
        const src = dfWidgetJsScript && (dfWidgetJsScript as HTMLElement).getAttribute('src');
        return src && src.indexOf('?v2') > -1;
    }

    public static isDfFormIFrame() {
        return window.self !== window.top;
    }

    public static parseFunction(fnString: string) {
        const fnBodyIdx = fnString.indexOf('{'),
            fnBody = fnString.substring(fnBodyIdx + 1, fnString.lastIndexOf('}')),
            fnDeclare = fnString.substring(0, fnBodyIdx),
            fnParams = fnDeclare.substring(fnDeclare.indexOf('(') + 1, fnDeclare.lastIndexOf(')')),
            args = fnParams.split(',');
      
        args.push(fnBody);
      
        function Fn() {
            //@ts-ignore
          return Function.apply(this, args);
        }
        Fn.prototype = Function.prototype;
        //@ts-ignore
        return new Fn();
      }

      public static getCountryCode() {
        const widget = window['DepositFixForm']?.widget;

        return Promise.resolve({
            ip: '',
            country_code: (Object.keys(widget).length > 0 && widget.getHubSpotForm()?.hubSpotApi?._getState()?.countryCode) || ''
        });
      }

}
